var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mx-auto"},[_c('div',{staticClass:"py-4 px-4 border border-black items-center leading-none rounded-lg",attrs:{"role":"alert"}},[_c('span',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }